<template>
  <div id="app">
    <main>
      <RouterView></RouterView>
    </main>
    <footer class="flex flex-col">
      <a href="https://newsapi.org" target="_blank" rel="noopener noreferrer">Powered by News API</a>
      <a href="https://github.com/caripizza" target="_blank" rel="noopener noreferrer">by @caripizza</a>
    </footer>
  </div>
</template>

<script>
export default {};
</script>

<style>
@import '../node_modules/@caripizza/ui/dist/output.css';
body {
  --bg-color: rgb(var(--backg-primary) / 1);
  --txt-color: rgb(var(--text-primary) / 1);
  background-color: var(--bg-color);
  color: var(--txt-color);
  margin: 0 1rem;
  padding: 0.25rem 1.5rem;
  --footer-height: 80px;
  --header-height: 115px;
  --box-shadow-lg: rgba(0, 0, 0, 0) 0px 0px 0px 0px,
      rgba(0, 0, 0, 0) 0px 0px 0px 0px,
      rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
      rgba(0, 0, 0, 0.1) 0px 4px 6px -4px;
}
#app {
  margin-bottom: var(--footer-height);
}
h2 {
  display: block;
  font-size: 1.5em;
  margin-block: 0.5rem;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}
a {
  color: blue;
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  text-decoration: underline;
}
footer {
  background-color: rgb(var(--color-gold) / 1);
  justify-content: flex-end;
  height: 80px;
  width: 100%;
  bottom: 0;
  position: fixed;
  left: 0;
  padding: 1rem;
}
.error {
  color: red;
  vertical-align: middle;
}
</style>
